// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/main.scss
// module id = 2
// module chunks = 0